import React, { useState } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Login from "./authPages/Login";
import Register from "./authPages/Register";

import AdminLayout from "./layouts/Admin/Admin.js";
import RTLLayout from "./layouts/RTL/RTL.js";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase/firebase-config";
import All_Users_beyown from "./views/All_Users_beyown";
import SingleUserProfile from "./components/SingleUser/SingleUserProfile";
import GoogleScreen from "./components/GoogleScreen";
import { GoogleLoginContext } from "./contexts/GoogleLoginContext";
import ProtectedRoute from "./authPages/ProtectedRoutes";
import Card from "./components/Card.js";

const App = () => {
  const [user, loading] = useAuthState(auth);
  const [profile, setProfile] = useState();
  const [token, setToken] = useState();
  // const clientId =
  //   "1093825263344-d1lagd36uf655jn024qku0h5qn1vjuaf.apps.googleusercontent.com";
  const clientId =
    "960894969461-i0sn4egkn76c1g0photl1q1ijl47l1jh.apps.googleusercontent.com";

  const ProfileAdded = (profile) => {
    setProfile(profile);
  };
  const ProfileRemoved = () => {
    console.log(profile);

    setProfile(null);
    console.log(profile);
  };
  const isAuthenticated = user;

  return (
    <BrowserRouter>
      <GoogleLoginContext.Provider
        value={{
          profile,
          ProfileAdded,
          ProfileRemoved,
          clientId,
          token,
          setToken,
        }}
      >
        <Switch>
          <ProtectedRoute
            path="/admin"
            component={AdminLayout}
            isAuthenticated={isAuthenticated}
          />

          {/* <Route path="/admin" render={(props) =>
            <AdminLayout {...props} />
          } /> */}

          <Route path="/rtl" render={(props) => <RTLLayout {...props} />} />
          <Route path="/Login" render={(props) => <Login {...props} />} />
          <Route path="/Register" render={(props) => <Register {...props} />} />
          <Route
            path="/Google-Analytics-connect"
            render={(props) => <GoogleScreen {...props} />}
          />
          <Route path="/card" exact>
            <Card />
          </Route>

          <Redirect from="/" to="/Login" />
        </Switch>
      </GoogleLoginContext.Provider>
    </BrowserRouter>
  );
};

export default App;
// admin/users/total-beyown-users/single_user/${user?.id}
